import React from 'react';
import { useSelector } from 'react-redux';

import _ from 'underscore';
import { Form, Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';
import { ListSubtotal } from 'ui/components';
import { currencyFormat } from 'utilities/common';

const PaymentMethods = [
  { value: 'Kas Tunai', label: 'Kas Tunai' },
  { value: 'Cek&Giro', label: 'Cek & Giro' },
  { value: 'Transfer Bank', label: 'Transfer Bank' },
  { value: 'Kartu Kredit', label: 'Kartu Kredit' },
];

const initialState = {
  subtotal: null,
  discountLine: null,
  discount: null,
  taxes: [],
  subtotal_tax: null,
  down_payment: null,
  isDp: false,
  pph: null,
};

export const FormSubtotal = ({
  project,
  onChange,
  products,
  data,
  isLoading
}) => {
  const StateForm = useSelector((state) => state?.Form);
  const [
    { subtotal, discountLine, discount, taxes, subtotal_tax, pph, down_payment, isDp },
    setState,
  ] = React.useState(initialState);

  const $pphNominal = () => {
    let nominal = (subtotal - discountLine - discount) * (pph / 100)

    if (nominal > 0) {
      nominal = nominal.toFixed(2)
    }

    return parseFloat(nominal)
  }

  const $totalCharges = () => {
    let dpn = 0
    if (down_payment) {
      dpn = down_payment?.nominal
    }

    return (((subtotal - discountLine - discount) + subtotal_tax - $pphNominal()) - dpn).toFixed(2)
  }

  React.useEffect(() => {
    let dp = null

    if (isDp && down_payment) {
      dp = {
        id: down_payment?.id,
        nominal: down_payment?.nominal,
        payment_method: down_payment?.payment_method?.value,
      }
    }

    onChange({
      discount,
      pph,
      down_payment: dp
    });
  }, [discount, pph, down_payment])

  React.useEffect(() => {
    let discbagiproduct = discount / products?.length
    let subtotal = 0
    let discountLine = 0
    let subtotalTax = 0
    let taxes = []

    _.map(products, (i) => {
      let upq = i?.unit_price * i?.quantity

      subtotal += upq
      discountLine += i?.discount

      if (i?.tax) {
        let tax = {
          label: i?.tax?.label,
          value: i?.tax?.value,
          nominal: ((upq - i?.discount - discbagiproduct) * (i?.tax?.value / 100)).toFixed(2)
        }

        tax.nominal = parseFloat(tax.nominal);

        let isUnique = false
        _.each(taxes, (ix) => {
          if (ix.label === tax?.label) {
            ix.nominal += tax.nominal

            isUnique = true;

            return
          }
        })

        if (!isUnique) {
          taxes.push(tax)
        }

        subtotalTax += tax?.nominal
      }
    })

    setState((prevState) => ({...prevState, subtotal: subtotal, discountLine: discountLine, taxes: taxes, subtotal_tax: subtotalTax}));
  }, [products, discount])

  React.useEffect(() => {
    if (!data) return

    let dp = null
    let isDp = false
    if (data?.payments?.length > 0) {
      let ivpay = data?.payments[0]

      let pm = null
      if (ivpay?.payment_method) {
        _.each(PaymentMethods, (i) => {
          if (i?.value === ivpay?.payment_method) {
            pm = i
          }
        })
      }

      dp = {
        id: ivpay?.id,
        nominal: ivpay?.nominal,
        payment_method: pm
      }

      isDp = true
    }

    setState((prevState) => ({...prevState, discount: data?.discount, pph: data?.pph_percentage, isDp: isDp, down_payment: dp}));
  }, [data])

  const $handleDownPaymentChange = async (e, n) => {
    let newDp = { ...down_payment};

    if (n === 'is_dp') {
      let dp = false
      newDp = {nominal: 0, payment_method: null}

      if (!isDp) {
        dp = true
      } else {
        dp = false
      }

      setState((prevState) => ({...prevState, isDp: dp, down_payment: newDp}));
    }else {
      if (n === 'nominal') {
        newDp[n] = e?.target?.valueNumber
      }

      if (n === 'payment_method') {
        newDp[n] = e
      }

      setState((prevState) => ({...prevState, down_payment: newDp}));
    }
  }

  return isLoading ? (
    <SkeletonsForm count={5} />
  ) : (
    <div className="mb-1">
      <ListSubtotal
        colTitle='fs-5 fw-semibold'
        title="Subtotal"
        content={currencyFormat(subtotal || 0)}
      />

      <ListSubtotal
        colTitle='fs-7'
        title="Diskon Perbaris"
        content={currencyFormat(discountLine || 0)}
        colContent='fs-7'
      />

      <div className='row border-bottom'>
        <div className='col-6'>
          <Form.Input
            value={discount}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                discount: e.target.valueNumber,
              }))
            }
            type="number"
            label="Diskon (Rp)"
            disabled={subtotal <= 0}
          />
        </div>
        <div className='col-6'>
          <ListSubtotal
            className='border-0 mt-2'
            content={currencyFormat(discount || 0)}
            colContent='fs-7'
          />
        </div>
      </div>

      {taxes && taxes?.map((e, i) => (
        <ListSubtotal
          className='border-0'
          colTitle='fs-7'
          title={e?.label}
          content={currencyFormat(e?.nominal || 0)}
          colContent='fs-7'
        />
      ))}

      <div className='row border-bottom'>
        <div className='col-6'>
          <Form.Input
            value={pph}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                pph: e.target.valueNumber,
              }))
            }
            type="number"
            label="PPH (%)"
            disabled={subtotal <= 0}
          />
        </div>
        <div className='col-6'>
          <ListSubtotal
            className='border-0 mt-2'
            content={$pphNominal() > 0 ? `(${currencyFormat($pphNominal())})` : 0}
            colContent='fs-7'
          />
        </div>
      </div>

      <div className='row my-1'>
        <div className='col-6'>
          <Form.Checkbox
            onChange={(e) => $handleDownPaymentChange(e, 'is_dp')}
            iconSize={18}
            value={isDp}
            label="Pemotongan"
          />
        </div>
        {isDp && (
          <>
            <div className='col-6'>
              <Form.Input
                value={down_payment?.nominal}
                onChange={(e) => $handleDownPaymentChange(e, 'nominal')}
                type="number"
                error={StateForm?.errors?.['down_payment.nominal']}
              />
            </div>
            <div className='col-12'>
              <Select
                isClearable
                classNamePrefix='select'
                placeholder=""
                value={down_payment?.payment_method}
                options={PaymentMethods}
                onChange={(e) => $handleDownPaymentChange(e, 'payment_method')}
                error={StateForm?.errors?.['down_payment.payment_method']}
              />

              {StateForm?.errors?.['down_payment.payment_method'] ? (
                <div
                  className="invalid-feedback"
                  style={{ display: 'block' }}
                >
                  {StateForm?.errors?.['down_payment.payment_method']}
                </div>
              ) : null}
            </div>
          </>
        )}
      </div>
      <ListSubtotal
        colTitle='fs-4 fw-semibold'
        title="Total Tagihan"
        content={currencyFormat($totalCharges() || 0)}
        colContent='fs-4'
      />
    </div>
  );
};
